// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Compass, SignOut, UserCircle } from "@phosphor-icons/react";
import { BACKEND_URL } from "../lib/api";

export default function Header() {
  const { user, logout, myCreator } = useAuth();
  const location = useLocation();

  const handleLogin = () => {
    if (!BACKEND_URL) return;
    const redirectUrl = `${window.location.origin}/#/auth/callback`;
    window.location.href = `${BACKEND_URL}/api/auth/google/login?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const navItems = [
    { to: "/", label: "Home" },
    { to: "/explore", label: "Explore" },
    { to: "/routes", label: "Routes" },
    { to: "/about", label: "About" },
  ];
  if (user) navItems.push({ to: "/favorites", label: "Saved" });
  if (user?.is_admin) navItems.push({ to: "/admin", label: "Admin" });

  return (
    <header
      className="sticky top-0 z-40 bg-[#F9F6F0]/80 backdrop-blur-xl border-b border-[#E5E0D8]/60"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          data-testid="logo-link"
        >
          <Compass
            size={28}
            weight="duotone"
            className="text-[#2C5545] group-hover:rotate-45 transition-transform duration-500"
          />
          <span className="font-display font-black text-xl tracking-tight text-[#1A1D1A]">
            Discover By Bike
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={`text-sm font-semibold tracking-wide uppercase transition-colors ${
                location.pathname === item.to
                  ? "text-[#C86B4E]"
                  : "text-[#1A1D1A] hover:text-[#2C5545]"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <div className="flex items-center gap-3" data-testid="user-section">
              {user.picture ? (
                <img
                  src={user.picture}
                  alt={user.name}
                  className="w-8 h-8 rounded-full border border-[#E5E0D8]"
                />
              ) : (
                <UserCircle size={32} className="text-[#5C665F]" />
              )}
              <span
                className="hidden sm:inline text-sm font-medium text-[#1A1D1A]"
                data-testid="user-name"
              >
                {user.name?.split(" ")[0]}
              </span>
              {/* Creator profile button */}
              <Link to="/creator">
                <Button className="hidden sm:inline bg-transparent border border-[#E5E0D8] text-sm px-3 py-1">
                  {myCreator ? "Edit Profile" : "Become a Creator"}
                </Button>
              </Link>
              {myCreator && (
                <Link to="/creator/studio">
                  <Button className="hidden sm:inline bg-[#2C5545] text-white text-sm px-3 py-1 hover:bg-[#18382E] hover:text-white">
                    Studio
                  </Button>
                </Link>
              )}
              <button
                onClick={logout}
                data-testid="logout-button"
                className="p-2 rounded-full hover:bg-[#E5E0D8]/60 transition-colors"
                aria-label="Logout"
              >
                <SignOut size={18} className="text-[#5C665F]" />
              </button>
            </div>
          ) : (
            <Button
              onClick={handleLogin}
              data-testid="login-button"
              className="bg-[#2C5545] text-white hover:bg-[#18382E] hover:text-white rounded-full px-5 py-2 font-bold"
            >
              Sign in
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
